let BACKEND_SERVER = null;

if (process.env.NODE_ENV === "production") {
  BACKEND_SERVER = "https://api.smartbustw.com/";
} else {
  BACKEND_SERVER = "https://api.smartbustw.com/";
}


export const API_SERVER = BACKEND_SERVER;
